<template>
  <div class="content-box" v-if="!isFiltered && originalProductList.length > 0">
    <div class="product-search-wrap">
      <div class="search-title-box mb60">
        <div class="sub-title-area" v-if="isSelectedCate">
          <h2 class="fs38 font-bold ta-c"><span class="text-green">{{ searchText }}</span>(으)로 검색한 결과입니다.</h2>
        </div>
        <HconTitle v-if="!isSelectedCate" subTitle="Hcon 모바일 쿠폰" subDescription="합리적인 혜택, 믿을 수 있는 쿠폰 서비스 Hcon에서 시작하세요." />
      </div>
      <div class="search-list-box">
        <!-- 상품 필터 s -->
        <div class="product-filter-area">
          <div class="contents-title-wrap mb28 pb30 pt11">
            <div class="contents-title">
              <h3 class="mr9 fs18">필터</h3>
            </div>
            <div class="rgt-area">
              <button type="button" class="link reset" @click="resetAllSearchResult()">초기화</button>
            </div>
          </div>
          <div class="filter-box">
            <ul class="filter-list">
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isCategoryVisible}" @click="handleCategoryPreview('cate')">카테고리</button>
                <ul v-if="isCategoryVisible" class="depth1-group mt20">
                  <li v-for="depth1 in filterMenuData" :key="depth1.id" :class="{ active: selectedDepth1.includes(depth1.id) }" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth1.text}`" :showTextAfter="true" :text="`(${depth1.qty})`" textClass="filter-num" name="checkCategoryType1" :checked="selectedDepth1.includes(depth1.id) " :hide-label="false" @click="selectDepth1(depth1.id)" @mousedown="handlePreventJump($event, () => selectDepth1(depth1.id))"/>
                      <ul v-if="selectedDepth1.includes(depth1.id) && has2DepthChild(depth1)" class="depth2-group">
                      <li v-for="depth2 in filter2DepthItems(depth1.child || [])" :key="depth2.id" class="filter-item">
                        <HconCheckBox type="default" :label="`${depth2.text}`" :showTextAfter="true" :text="`(${depth2.qty})`" textClass="filter-num"  name="checkCategoryType2" :checked="selectedDepth2.includes(depth2.id)" :hide-label="false" @click="selectDepth2(depth2.id)" @mousedown="handlePreventJump($event, () => selectDepth2(depth2.id))" />
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isBrandVisible}" @click="handleCategoryPreview('brand')">브랜드</button>
                <ul v-if="depth3List.length && isBrandVisible" class="depth3-group mt20">
                  <li v-for="depth3 in depth3List" :key="depth3.id" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth3.text}`" :showTextAfter="true" :text="`(${depth3.qty})`" textClass="filter-num"  name="checkBrandType" :checked="selectedDepth3.includes(depth3.id)" :hide-label="false" @click="selectDepth3(depth3.id)" @mousedown="handlePreventJump($event, () => selectDepth3(depth3.id))"/>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isPriceVisible}" @click="handleCategoryPreview('price')">가격</button>
                <div v-if="isPriceVisible" class="mt20">
                  <ul class="depth4-group">
                    <li v-for="(price, index) in priceRangeList" :key="index" class="filter-item">
                      <HconRadioBox :value="`${price.value}`" :label="`${price.text}`" v-model:model-value="searchPriceRange"  :id="'priceRngType'" :name="'priceRngType'" :hide-label="false" />
                    </li>
                  </ul>
                  <div class="price-range-box">
                    <div class="form-box">
                      <div class="form-group row">
                        <HconInput v-model="searchMinPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="0원" />
                        <span class="ml4 mr4">-</span>
                        <HconInput v-model="searchMaxPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="999,999원" />
                      </div>
                    </div>
                  </div>
                  <div class="button-box mt8">
                    <button type="button" class="btn full" @click="filterProductList()">조회</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 상품 필터 e -->
        <!-- 상품 리스트 s -->
        <div class="product-list-area">
          <div class="contents-title-wrap mb28 pb20">
            <div class="contents-title">
              <p class="text-gray font-bold">검색결과 <span class="text-green">{{ totalData }}</span>개</p>
            </div>
            <div class="rgt-area">
              <ul class="li-bar sort-list mr20">
                <li v-for="(item, index) in sortList" :key="index" class="fs14" :class="{ 'active': activeId === item.id}">
                  <button type="button" class="sort-btn" @click="selectItem(item.id)">{{ item.text }}</button>
                </li>
              </ul>
              <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
            </div>
          </div>
          <ul v-if="productList.length > 0" class="srch-product-list">
            <li v-for="(proItem, index) in productList" :key="proItem.id+'-'+index" class="product-li">
              <HconProductItem @open-popup="showAddedGoodsImportPopup" viewType="column" :useControl="true" :hideInfo="false" :item="proItem"/>
            </li>
          </ul>
          <ul v-if="isFiltered && productList.length == 0" class="srch-product-list">
            <li class="nodata">
              <strong>필터 적용된 검색 결과가 없습니다.</strong>
              <span>필터를 해제하시거나, 다른 검색어를 입력해 보세요.</span>
            </li>
          </ul>
          <div v-if="productList.length < totalData &&   totalData > rowPerPage" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ productList.length }} <span class="text-gray02">/ {{totalData}}</span></span></button>
          </div>
          <!-- <div v-if="isFiltered && prodListDisplay < productList.length" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ prodListDisplay }} <span class="text-gray02">/ {{productList.length}}</span></span></button>
          </div> -->
        </div>
        <!-- 상품 리스트 e -->
      </div>
    </div>
  </div>
  <div class="content-box" v-if="!isFiltered && originalProductList.length == 0">
    <div class="product-search-wrap no-search">
      <div class="search-title-box mb80">
        <div class="sub-title-area">
            <h2 class="fs38 font-bold ta-c" v-if="isSelectedCate"><span class="text-green">{{ searchText }}</span>(으)로 검색한 결과가 없습니다.</h2>
        </div>
        <HconTitle v-if="!isSelectedCate" subTitle="Hcon 모바일 쿠폰" subDescription="합리적인 혜택, 믿을 수 있는 쿠폰 서비스 Hcon에서 시작하세요." />
      </div>
      <div class="popular-pro-list-box mb40">
        <!-- 상품 리스트 s -->
        <div class="product-list-area">
          <div class="contents-title-wrap mb32">
            <div class="contents-title">
              <h3 class="text-gray font-bold fs26 mr0">Hcon 인기상품</h3>
            </div>
          </div>
          <ul class="popular-pro-list">
            <li v-for="proItem in productList" :key="proItem.id" class="product-li">
              <HconProductItem @open-popup="showAddedGoodsImportPopup" viewType="column" :useControl="true" :hideInfo="false" :item="proItem"/>
            </li>
          </ul>
        </div>
        <!-- 상품 리스트 e -->
      </div>
    </div>
  </div>
  <div class="content-box" v-if="isFiltered && originalProductList.length > 0">
    <div class="product-search-wrap">
      <div class="search-title-box mb60">
        <div class="sub-title-area" v-if="isSelectedCate">
          <h2 class="fs38 font-bold ta-c"><span class="text-green">{{ searchText }}</span>(으)로 검색한 결과입니다.</h2>
        </div>
        <HconTitle v-if="!isSelectedCate" subTitle="Hcon 모바일 쿠폰" subDescription="합리적인 혜택, 믿을 수 있는 쿠폰 서비스 Hcon에서 시작하세요." />
      </div>
      <div class="search-list-box">
        <!-- 상품 필터 s -->
        <div class="product-filter-area">
          <div class="contents-title-wrap mb28 pb30 pt11">
            <div class="contents-title">
              <h3 class="mr9 fs18">필터</h3>
            </div>
            <div class="rgt-area">
              <button type="button" class="link reset" @click="resetAllSearchResult()">초기화</button>
            </div>
          </div>
          <div class="filter-box">
            <ul class="filter-list">
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isCategoryVisible}" @click="handleCategoryPreview('cate')">카테고리</button>
                <ul v-if="isCategoryVisible" class="depth1-group mt20">
                  <li v-for="depth1 in filterMenuData" :key="depth1.id" :class="{ active: selectedDepth1.includes(depth1.id) }" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth1.text}`" :showTextAfter="true" :text="`(${depth1.qty})`" textClass="filter-num"  name="checkCategoryType1" :checked="selectedDepth1.includes(depth1.id) " :hide-label="false" @click="selectDepth1(depth1.id)" @mousedown="handlePreventJump($event, () => selectDepth1(depth1.id))"/>
                      <ul v-if="selectedDepth1.includes(depth1.id) && has2DepthChild(depth1)" class="depth2-group">
                      <li v-for="depth2 in filter2DepthItems(depth1.child || [])" :key="depth2.id" class="filter-item">
                        <HconCheckBox type="default" :label="`${depth2.text}`" :showTextAfter="true" :text="`(${depth2.qty})`" textClass="filter-num"  name="checkCategoryType2" :checked="selectedDepth2.includes(depth2.id) " :hide-label="false" @click="selectDepth2(depth2.id)" @mousedown="handlePreventJump($event, () => selectDepth2(depth2.id))" />
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isBrandVisible}" @click="handleCategoryPreview('brand')">브랜드</button>
                <ul v-if="depth3List.length && isBrandVisible" class="depth3-group mt20">
                  <li v-for="depth3 in depth3List" :key="depth3.id" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth3.text}`" :showTextAfter="true" :text="`(${depth3.qty})`" textClass="filter-num"  name="checkBrandType" :checked="selectedDepth3.includes(depth3.id)" :hide-label="false" @click="selectDepth3(depth3.id)" @mousedown="handlePreventJump($event, () => selectDepth3(depth3.id))"/>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isPriceVisible}" @click="handleCategoryPreview('price')">가격</button>
                <div v-if="isPriceVisible" class="mt20">
                  <ul class="depth4-group">
                    <li v-for="(price, index) in priceRangeList" :key="index" class="filter-item">
                      <HconRadioBox :value="`${price.value}`" :label="`${price.text}`" v-model:model-value="searchPriceRange"  :id="'priceRngType'" :name="'priceRngType'" :hide-label="false" />
                    </li>
                  </ul>
                  <div class="price-range-box">
                    <div class="form-box">
                      <div class="form-group row">
                        <HconInput v-model="searchMinPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="0원" />
                        <span class="ml4 mr4">-</span>
                        <HconInput v-model="searchMaxPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="999,999원" />
                      </div>
                    </div>
                  </div>
                  <div class="button-box mt8">
                    <button type="button" class="btn full" @click="filterProductList()">조회</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 상품 필터 e -->
        <!-- 상품 리스트 s -->
        <div class="product-list-area">
          <div class="contents-title-wrap mb28 pb20">
            <div class="contents-title">
              <p class="text-gray font-bold">검색결과 <span class="text-green">{{ totalData }}</span>개</p>
            </div>
            <div class="rgt-area">
              <ul class="li-bar sort-list mr20">
                <li v-for="(item, index) in sortList" :key="index" class="fs14" :class="{ 'active': activeId === item.id}">
                  <button type="button" class="sort-btn" @click="selectItem(item.id)">{{ item.text }}</button>
                </li>
              </ul>
              <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
            </div>
          </div>
          <ul v-if="productList.length > 0" class="srch-product-list">
            <li v-for="(proItem, index) in productList" :key="proItem.id+'-'+index" class="product-li">
              <HconProductItem @open-popup="showAddedGoodsImportPopup" viewType="column" :useControl="true" :hideInfo="false" :item="proItem"/>
            </li>
          </ul>
          <ul v-if="productList.length == 0" class="srch-product-list">
            <li class="nodata">
              <strong>필터 적용된 검색 결과가 없습니다.</strong>
              <span>필터를 해제하시거나, 다른 검색어를 입력해 보세요.</span>
            </li>
          </ul>
          <div v-if="productList.length < totalData &&   totalData > rowPerPage" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ productList.length }} <span class="text-gray02">/ {{totalData}}</span></span></button>
          </div>
          <!-- <div v-if="isFiltered && prodListDisplay < productList.length" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ prodListDisplay }} <span class="text-gray02">/ {{productList.length}}</span></span></button>
          </div> -->
        </div>
        <!-- 상품 리스트 e -->
      </div>
    </div>
  </div>
  <div class="content-box" v-if="isFiltered && originalProductList.length == 0">
    <div class="product-search-wrap">
      <div class="search-title-box mb60">
        <div class="sub-title-area" v-if="isSelectedCate">
          <h2 class="fs38 font-bold ta-c"><span class="text-green">{{ searchText }}</span>(으)로 검색한 결과입니다.</h2>
        </div>
        <HconTitle v-if="!isSelectedCate" subTitle="Hcon 모바일 쿠폰" subDescription="합리적인 혜택, 믿을 수 있는 쿠폰 서비스 Hcon에서 시작하세요." />
      </div>
      <div class="search-list-box">
        <!-- 상품 필터 s -->
        <div class="product-filter-area">
          <div class="contents-title-wrap mb28 pb30 pt11">
            <div class="contents-title">
              <h3 class="mr9 fs18">필터</h3>
            </div>
            <div class="rgt-area">
              <button type="button" class="link reset" @click="resetAllSearchResult()">초기화</button>
            </div>
          </div>
          <div class="filter-box">
            <ul class="filter-list">
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isCategoryVisible}" @click="handleCategoryPreview('cate')">카테고리</button>
                <ul v-if="isCategoryVisible" class="depth1-group mt20">
                  <li v-for="depth1 in filterMenuData" :key="depth1.id" :class="{ active: selectedDepth1.includes(depth1.id) }" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth1.text}`" :showTextAfter="true" :text="`(${depth1.qty})`" textClass="filter-num"  name="checkCategoryType1" :checked="selectedDepth1.includes(depth1.id) " :hide-label="false" @click="selectDepth1(depth1.id)" @mousedown="handlePreventJump($event, () => selectDepth1(depth1.id))"/>
                      <ul v-if="selectedDepth1.includes(depth1.id) && has2DepthChild(depth1)" class="depth2-group">
                      <li v-for="depth2 in filter2DepthItems(depth1.child || [])" :key="depth2.id" class="filter-item">
                        <HconCheckBox type="default" :label="`${depth2.text}`" :showTextAfter="true" :text="`(${depth2.qty})`" textClass="filter-num"  name="checkCategoryType2" :checked="selectedDepth2.includes(depth2.id) " :hide-label="false" @click="selectDepth2(depth2.id)" @mousedown="handlePreventJump($event, () => selectDepth2(depth2.id))" />
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isBrandVisible}" @click="handleCategoryPreview('brand')">브랜드</button>
                <ul v-if="depth3List.length && isBrandVisible" class="depth3-group mt20">
                  <li v-for="depth3 in depth3List" :key="depth3.id" class="filter-item">
                    <HconCheckBox type="default" :label="`${depth3.text}`" :showTextAfter="true" :text="`(${depth3.qty})`" textClass="filter-num"  name="checkBrandType" :checked="selectedDepth3.includes(depth3.id)" :hide-label="false" @click="selectDepth3(depth3.id)" @mousedown="handlePreventJump($event, () => selectDepth3(depth3.id))"/>
                  </li>
                </ul>
              </li>
              <li class="filter-menu">
                <button type="button" class="toggle-btn" :class="{active: isPriceVisible}" @click="handleCategoryPreview('price')">가격</button>
                <div v-if="isPriceVisible" class="mt20">
                  <ul class="depth4-group">
                    <li v-for="(price, index) in priceRangeList" :key="index" class="filter-item">
                      <HconRadioBox :value="`${price.value}`" :label="`${price.text}`" v-model:model-value="searchPriceRange"  :id="'priceRngType'" :name="'priceRngType'" :hide-label="false" />
                    </li>
                  </ul>
                  <div class="price-range-box">
                    <div class="form-box">
                      <div class="form-group row">
                        <HconInput v-model="searchMinPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="0원" />
                        <span class="ml4 mr4">-</span>
                        <HconInput v-model="searchMaxPriceStr" :max="7" type="pay" label="가격" :hide-label="true"  :showDeleteButton="false" placeholder="999,999원" />
                      </div>
                    </div>
                  </div>
                  <div class="button-box mt8">
                    <button type="button" class="btn full" @click="filterProductList()">조회</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 상품 필터 e -->
        <!-- 상품 리스트 s -->
        <div class="product-list-area">
          <div class="contents-title-wrap mb28 pb20">
            <div class="contents-title">
              <p class="text-gray font-bold">검색결과 <span class="text-green">{{ originalProductList.length }}</span>개</p>
            </div>
            <div class="rgt-area">
              <ul class="li-bar sort-list mr20">
                <li v-for="(item, index) in sortList" :key="index" class="fs14" :class="{ 'active': activeId === item.id}">
                  <button type="button" class="sort-btn" @click="selectItem(item.id)">{{ item.text }}</button>
                </li>
              </ul>
              <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
            </div>
          </div>
          <ul class="srch-product-list">
            <li class="nodata">
              <strong>필터 적용된 검색 결과가 없습니다.</strong>
              <span>필터를 해제하시거나, 다른 검색어를 입력해 보세요.</span>
            </li>
          </ul>
          <!-- <div v-if="productList.length < totalData" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ productList.length }} <span class="text-gray02">/ {{totalData}}</span></span></button>
          </div> -->
          <!-- <div v-if="isFiltered && prodListDisplay < productList.length" class="button-box more-btn mt60">
            <button type="button" @:click="addProduct" class="btn btn-outline md">더보기 <span class="fs14 ml10">{{ prodListDisplay }} <span class="text-gray02">/ {{productList.length}}</span></span></button>
          </div> -->
        </div>
        <!-- 상품 리스트 e -->
      </div>
    </div>
  </div>
<div v-if="loadingStatus.full" class="full-loading">
<HconLoading v-model="loadingStatus.full" />
</div>
<!-- 담긴상품불러오기 팝업 -->
<HconAddedGoodsImport :flag=false ref="popupAddedGoodsImportRef" />
</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconProductItem, { type ProductItemType } from '@/components/com/HconComPCProductItem.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconRadioBox from '@/components/com/HconComPCRadio.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'
import { COMMON_CODE, MEMBER_CODE } from '@/constants/hconMessageConstants'
import HconLoading from '@/components/com/HconComPCLoading.vue'; // loading
import HconAddedGoodsImport from '@/components/popup/HconAddedGoodsImport.vue'

import { isTemplateExpression } from 'typescript'
// 로딩바 타입 정의
export interface Loadingstatus {
  full: boolean
}

// 담긴상품불러오기 팝업
const popupAddedGoodsImportRef = ref<InstanceType<typeof HconAddedGoodsImport> | null>(null)
const showAddedGoodsImportPopup = () => {
  popupAddedGoodsImportRef.value?.handleOpen()
}

// loading-state라는 키값으로 전역 상태 생성(기본값 false)
const loadingStatus = useState<Loadingstatus>('loading-status', () => ({
  full: false //전역 레이아웃 로딩
}))
// 검색어명
const searchText = ref("")
const searchCate = ref("")
const searchHighCate = ref("")
const searchBrand = ref("")
const searchMassCd = ref("")
const route = useRoute();
// 브랜드/카테고리/인기상품 등 선택 유입 시 타이틀 영역 상태값
// 필터 대분류 보임/숨김 상태값
const isCategoryVisible = ref(true);
const isBrandVisible = ref(true);
const isPriceVisible = ref(true);
const searchPriceRange = ref("");
const fetchBuilder = useHconFetchBuilder();
const { refreshRecentSearchwords } = useHeader()

const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20); // 페이징 건수
const totalData   = ref<number>(0);  // 총 데이터 건수
const isFiltered = ref(false)
const userGrade = useHconAuthInfo().getIfPossible()?.userContext.userGrade;

onMounted(() => {
  activeId.value = 1  
  searchText.value = getQuery(route.query.searchWords)
  searchCate.value = getQuery(route.query.searchCategory)
  searchHighCate.value = getQuery(route.query.searchHighCategory)
  searchBrand.value = getQuery(route.query.searchBrand)
  searchMassCd.value = getQuery(route.query.searchMassCd)

  searchCategoryList()
})

type UserGrade = 'friends' | 'gold' | 'platinum' | 'black';
const myGrade = () => {
  if(!isLoggedIn.value) return 'platinum'

  if(userGrade == '1000') return 'friends'
  if(userGrade == '1010') return 'gold'
  if(userGrade == '1020') return 'platinum'
  if(userGrade == '9999') return 'black'

  return 'friends'
} 

// 필터 카테고리 타입 정의
interface depth3ChildMenu {
  id: string
  text: string
  qty: number
}

interface depth2ChildMenu {
  id: string
  text: string
  qty: number
  child?: depth3ChildMenu[]
}
interface CategoryRow {
  hcCtgrCd: string
  hcBrndCd: string | null
  highHcCtgrCd?: string | null
  hcCtgrNm: string
  level: number
  qty: number
  path: string
}

interface MenuData {
  hcCtgrCd: string 
  hcBrndCd: string | null
  id: string
  text: string
  qty: number
  child?: depth2ChildMenu[]
}

// 필터 카테고리 데이터
const filterMenuData = ref<MenuData[]>([]);

// 가격
const priceRangeList = ref([
  {value: "A", text: '~3천원'},
  {value: "B", text: '3~5천원'},
  {value: "C", text: '5천~1만원'},
  {value: "D", text: '1~3만원'},
  {value: "E", text: '3~5만원'},
  {value: "F", text: '5만원~'},
])

const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

const searchMinPrice = ref(0)
const searchMaxPrice = ref(0)
const searchMinPriceStr = ref("")
const searchMaxPriceStr = ref("")

// 정렬 데이터 타입 정의
interface SortData {
  id: number
  text: string
}

// 정렬 데이터
const sortList = ref<SortData[]>([
  {
    id: 1, text: '인기상품순'},
  {
    id: 2, text: '할인율순'},
  {
    id: 3, text: '낮은 가격순'},
  {
    id: 4, text: '높은 가격순'}
])

// 정렬 선택 아이템 초기값
const activeId = ref(sortList.value?.[0].id ?? null)

const sortProductList = () => {
  const list = [...originalProductList.value]
  
  switch(activeId.value) {
      case 1:
        list.sort((a,b) => Number(a.rank ?? 99999) - Number(b.rank ?? 99999))
        break
      case 2:
      list.sort((a,b) => {
          const aDc = Number(String(a.discount ?? '0').replace('%', ''))
          const bDc = Number(String(b.discount ?? '0').replace('%', ''))
          return bDc - aDc
        })
        break
      case 3:
      list.sort((a,b) => a.originalPrice - b.originalPrice)
        break
      case 4:
      list.sort((a,b) => b.originalPrice - a.originalPrice)
        break
    }

    productList.value = []
    productList.value = list

    searchText.value = getQuery(route.query.searchWords)
    loadingStatus.value.full = false
}

const selectItem = (id: number) => {
  activeId.value = id
  currentPage.value = 1
  rowPerPage.value = Number(stringRowPerPage.value)
  loadingStatus.value.full = true

  searchProductList('')
}



const prodListDisplay = ref(0);

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    loadingStatus.value.full = true

    searchProductList('')
  }
})

const productList = ref<ProductItemType[]>([])
const tmpProductList = ref<ProductItemType[]>([])
const originalProductList = ref<ProductItemType[]>([])

interface ProductItemBadge {
  key: string
  text: string
}

const getQuery = (v: any) => {
  if(v === undefined || v === null) return ''
  return Array.isArray(v) ? v[0] : String(v)
}
const isSelectedCate = computed(() => {
  const category = route.query.searchWords
  return category !== undefined && category !== null && category !== ''
})

watch(() => route.fullPath, async (newVal, oldVal) => {
  loadingStatus.value.full = true
  if(useHconAuthInfo().getIfPossible()){
    await refreshRecentSearchwords();
  }
  activeId.value = 1   

  searchText.value = ""
  searchCate.value = ""
  searchHighCate.value = ""
  searchBrand.value = ""
  searchMassCd.value = ""
  searchMinPrice.value = 0
  searchMaxPrice.value = 0
  searchMaxPriceStr.value = ""
  searchMinPriceStr.value = ""

  searchText.value = getQuery(route.query.searchWords)
  searchCate.value = getQuery(route.query.searchCategory)
  searchHighCate.value = getQuery(route.query.searchHighCategory)
  searchBrand.value = getQuery(route.query.searchBrand)
  searchMassCd.value = getQuery(route.query.searchMassCd)

  await searchCategoryList();

})

watch(
  ()=> filterMenuData.value,
  (list) => {
    if (!list?.length) return
    initAllDepthSelected()
  },
  {immediate:true, deep: true}
)

watch(
  [() => searchMinPriceStr.value , () => searchMaxPriceStr.value],
  ([min,max]) => {

    searchMinPrice.value = Number(min.replace(',',''))
    searchMaxPrice.value = Number(max.replace(',',''))
    if(searchPriceRange.value != ''){
    if (searchMinPrice.value == 0 && searchMaxPrice.value == 0) {
      searchPriceRange.value = ''
    }
    }

  }
)

watch(
  () => searchPriceRange.value,
  (range) => {

      if(range == 'A') {
      // searchMinPrice.value = 0
      // searchMaxPrice.value = 3000
      searchMinPriceStr.value = '0'
      searchMaxPriceStr.value = '3000'
    } else if (range == 'B') {
      // searchMinPrice.value = 3000
      // searchMaxPrice.value = 5000
      searchMinPriceStr.value = '3000'
      searchMaxPriceStr.value = '5000'
    } else if (range == 'C') {
      // searchMinPrice.value = 5000
      // searchMaxPrice.value = 10000
      searchMinPriceStr.value = '5000'
      searchMaxPriceStr.value = '10000'
    } else if (range == 'D') {
      // searchMinPrice.value = 10000
      // searchMaxPrice.value = 30000
      searchMinPriceStr.value = '10000'
      searchMaxPriceStr.value = '30000'
    } else if (range == 'E') {
      // searchMinPrice.value = 30000
      // searchMaxPrice.value = 50000
      searchMinPriceStr.value = '30000'
      searchMaxPriceStr.value = '50000'
    } else if (range == 'F'){
      // searchMinPrice.value = 50000
      // searchMaxPrice.value = 99999999
      searchMinPriceStr.value = '50000'
      searchMaxPriceStr.value = '999999'
    } else {
      searchMinPrice.value = Number(searchMinPriceStr.value.replace(',',''))
      searchMaxPrice.value = Number(searchMaxPriceStr.value.replace(',',''))
    }

    // if(range && (searchMaxPrice.value || searchMinPrice.value)) {
    //   searchMinPriceStr.value = '0'
    //   searchMaxPriceStr.value = '0'
    //   searchMaxPrice.value = 0
    //   searchMinPrice.value = 0
    // }
  }
)

const searchProductList = async (flag : string) => {

  if(flag == 'init') {
    currentPage.value = 1
    prodListDisplay.value = 0
  } else if (flag != 'add') {
    const range = searchPriceRange.value
    if(range == 'A') {
      searchMinPrice.value = 0
      searchMaxPrice.value = 3000
    } else if (range == 'B') {
      searchMinPrice.value = 3000
      searchMaxPrice.value = 5000
    } else if (range == 'C') {
      searchMinPrice.value = 5000
      searchMaxPrice.value = 10000
    } else if (range == 'D') {
      searchMinPrice.value = 10000
      searchMaxPrice.value = 30000
    } else if (range == 'E') {
      searchMinPrice.value = 30000
      searchMaxPrice.value = 50000
    } else if (range == 'F'){
      searchMinPrice.value = 50000
      searchMaxPrice.value = 99999999
    } else {
      searchMinPrice.value = Number(searchMinPriceStr.value.replace(',',''))
      searchMaxPrice.value = Number(searchMaxPriceStr.value.replace(',',''))
    }
  }

  const pageSize = ref(rowPerPage.value)
  
  if( getQuery(route.query.searchBrand) != '') {
    searchHighCate.value = getQuery(route.query.searchHighCategory)
    searchCate.value = getQuery(route.query.searchCategory)
    searchBrand.value = getQuery(route.query.searchBrand)
  }

  const cleanedSearchParams = getCleanParams({searchWords: searchText.value    
                                              ,searchCategory: searchCate.value 
                                              ,searchHighCategory: searchHighCate.value 
                                              ,searchBrand: searchBrand.value 
                                              ,searchMassCd: searchMassCd.value
                                              ,pageNum: currentPage.value
                                              ,pageSize: pageSize.value
                                              ,searchOrdering: activeId.value
                                              ,searchMinPrice: searchMinPrice.value
                                              ,searchMaxPrice: searchMaxPrice.value})

  fetchBuilder.get<AjaxResult<any>>('/api/v1/product/search')
      .query(cleanedSearchParams)
      .build()
      .execute()
      .then((result) => {

        if(flag == 'add') {
          productList.value = [];
        } else {
          originalProductList.value = [];
        }

        tmpProductList.value = [];

        if(result.data.length == 0) {
          searchNoResultProductList()
        } else {
          totalData.value = result.total

          result.data.forEach((item: any) => {
                const badgeListTmp = ref<ProductItemBadge[]>([])

                if(item.mssBuyGdsYn == "Y") {
                  badgeListTmp.value.push({key: 'bulk', text: '대량구매 ' + item.buyPossMinQty.toLocaleString() + '개'})
                }

                if(item.prmGdsYn == "Y") {
                  badgeListTmp.value.push({key: 'event', text: 'EVENT'})
                }
       
                if(item.rank != null && item.rank != '' && Number(item.rank) != 0) {
                  badgeListTmp.value.push({key: 'hot', text: 'HOT'})
                }
                
                if(item.newDspGdsYn == "Y") {
                  badgeListTmp.value.push({key: 'new', text: 'NEW'})
                }

                const hcSellStCdTmp = item.hcDspStCd=='2003'?'exhDiscont':item.hcDspStCd=='2001'?'exhBefore':'';
                
                if(flag == 'init') {
                  originalProductList.value.push({
                    isCashable: item.cshabGdsYn=='Y'?true:false,
                    hcBrndCd: item.hcBrndCd,
                    hcDspGdsCd: item.hcDspGdsCd,
                    hcCtgrCd : item.hcCtgrCd,
                    id: item.hcGdsCd,
                    company: item.brndNm,
                    name: item.hcDspGdsNm,
                    link: '/pc/product/detail/' + item.hcDspGdsCd,
                    rank: searchMassCd.value=='best100'&&item.rcmmGdsRank<31?item.rcmmGdsRank:0,
                    discount: item.dcRt??'0' +'%',
                    price: item.sellPrc,
                    originalPrice: item.nrmlSellPrc,
                    thumb: cu.getFileFullUrl(item.cpnTnailImgPath),
                    alt: item.cpnTnailImgFileNm,
                    status: hcSellStCdTmp,
                    badge: badgeListTmp.value,
                    isHighest: item.highestRealSellPrcYn === 'Y' ? true : false,
                  })
              } else if (flag == 'add'){
                tmpProductList.value.push({
                    isCashable: item.cshabGdsYn=='Y'?true:false,
                    hcBrndCd: item.hcBrndCd,
                    hcDspGdsCd: item.hcDspGdsCd,
                    hcCtgrCd : item.hcCtgrCd,
                    id: item.hcGdsCd,
                    company: item.brndNm,
                    name: item.hcDspGdsNm,
                    link: '/pc/product/detail/' + item.hcDspGdsCd,
                    rank: searchMassCd.value=='best100'?item.rcmmGdsRank:0,
                    discount: item.dcRt??'0' +'%',
                    price: item.sellPrc,
                    originalPrice: item.nrmlSellPrc,
                    thumb: cu.getFileFullUrl(item.cpnTnailImgPath),
                    alt: item.cpnTnailImgFileNm,
                    status: hcSellStCdTmp,
                    badge: badgeListTmp.value,
                    isHighest: item.highestRealSellPrcYn === 'Y' ? true : false,
                  })
              } else {
                originalProductList.value.push({
                    isCashable: item.cshabGdsYn=='Y'?true:false,
                    hcBrndCd: item.hcBrndCd,
                    hcDspGdsCd: item.hcDspGdsCd,
                    hcCtgrCd : item.hcCtgrCd,
                    id: item.hcGdsCd,
                    company: item.brndNm,
                    name: item.hcDspGdsNm,
                    link: '/pc/product/detail/' + item.hcDspGdsCd,
                    rank: searchMassCd.value=='best100'?item.rcmmGdsRank:0,
                    discount: item.dcRt??'0' +'%',
                    price: item.sellPrc,
                    originalPrice: item.nrmlSellPrc,
                    thumb: cu.getFileFullUrl(item.cpnTnailImgPath),
                    alt: item.cpnTnailImgFileNm,
                    status: hcSellStCdTmp,
                    badge: badgeListTmp.value,
                    isHighest: item.highestRealSellPrcYn === 'Y' ? true : false,
                  })
              }
            })
          }

          if(flag == 'init') {
            isFiltered.value = false
            activeId.value = 1
            productList.value = [...originalProductList.value]
            prodListDisplay.value += productList.value.length;
          } else if (flag == 'add'){
            originalProductList.value.push(...tmpProductList.value)
            productList.value.push(...originalProductList.value)
            prodListDisplay.value += pageSize.value;
          } else {
            productList.value = []
            // prodListDisplay.value += originalProductList.value.length;
            productList.value = [...originalProductList.value]
          }

          sortProductList();
      })
}

const searchNoResultProductList = async () => {
  fetchBuilder.get<AjaxResult<any>>('/api/v1/product/search/popular')
    .query()  
    .build()
      .execute()
      .then((result) => {
        productList.value = [];
        originalProductList.value = [];
        prodListDisplay.value = rowPerPage.value;

        result.data.forEach((item: any) => {
              const badgeListTmp = ref<ProductItemBadge[]>([])

              if(item.mssBuyGdsYn == "Y") {
                badgeListTmp.value.push({key: 'bulk', text: '대량구매 ' + item.buyPossMinQty.toLocaleString() + '개'})
              }

              if(item.prmGdsYn == "Y") {
                badgeListTmp.value.push({key: 'event', text: 'EVENT'})
              }
              
              if(item.rank != null && item.rank != '' && Number(item.rank) != 0) {
                badgeListTmp.value.push({key: 'hot', text: 'HOT'})
              }

              if(item.newDspGdsYn == "Y") {
                  badgeListTmp.value.push({key: 'new', text: 'NEW'})
              }
              
              const hcSellStCdTmp = item.hcDspStCd=='2003'?'exhDiscont':item.hcDspStCd=='2001'?'exhBefore':'';

              productList.value.push({
                hcBrndCd: item.hcBrndCd,
                hcDspGdsCd: item.hcDspGdsCd,
                hcCtgrCd : item.hcCtgrCd,
                id: item.hcGdsCd,
                company: item.brndNm,
                name: item.hcDspGdsNm,
                link: '/pc/product/detail/' + item.hcDspGdsCd,
                rank: item.rcmmGdsRank,
                discount: item.dcRt??'0' +'%',
                price: item.sellPrc,
                originalPrice: item.nrmlSellPrc,
                thumb: cu.getFileFullUrl(item.cpnTnailImgPath),
                alt: item.cpnTnailImgFileNm,
                status: hcSellStCdTmp,
                badge: badgeListTmp.value,
                isHighest: item.highestRealSellPrcYn === 'Y' ? true : false,
              })

              productList.value.sort((a,b) => Number(a.rank ?? 99999) - Number(b.rank ?? 99999))
          })
      })
}
// 전역 팝업 설정
const { openLoginPopup, isLoggedIn, showConfirm, showAlert} = usePopup()

const getCleanParams = <T extends Record<string, any>>(obj: T) => {
  // 1. reactive 객체에서 순수 데이터만 추출
  const rawObj = toRaw(obj)

  // 2. 키/값 쌍을 순회하며 유효한 값만 필터링
  return Object.fromEntries(
    Object.entries(rawObj).filter(([_, value]) => {
      return value !== null && value !== undefined && value !== '' && value !== 0
    })
  )
}


const searchCategoryList = async () => {

  if(searchMinPrice.value > searchMaxPrice.value) {
    showAlert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "가격범위를", "확인"));
    return false;
  }

  fetchBuilder.get<AjaxResult<any>>('/api/v1/product/search/category')
      .query(getCleanParams({searchWords: searchText.value    
              ,searchCategory: searchCate.value 
              ,searchHighCategory: searchHighCate.value 
              ,searchBrand: searchBrand.value 
              ,searchMassCd: searchMassCd.value 
              ,searchMinPrice: searchMinPrice.value
              ,searchMaxPrice: searchMaxPrice.value
      }))
      .build()
      .execute()
      .then((result) => {
        filterMenuData.value= []
        filterMenuData.value = buildCategoryTree(result.data).filter(item => item && item.qty > 0);

        initSelectedCategoryByCode();
        searchProductList('init');
      })
}

const initSelectedCategoryByCode = () => {

  selectedDepth1.value = []
  selectedDepth2.value = []
  selectedDepth3.value = []

  if(searchBrand.value) {
    const depth3 = findDepth3ByCode(filterMenuData.value, searchHighCate.value, searchCate.value, searchBrand.value)
    if(!depth3) return

    const depth2Id = depth3.id.split('-').slice(0, 2).join('-')
    const depth1Id = depth3.id.split('-')[0]

    selectedDepth1.value = [depth1Id]
    selectedDepth2.value = [depth2Id]
    selectedDepth3.value = [depth3.id]
    return
  }

  if(searchCate.value) {
    const depth2 = findDepth2ByCode(filterMenuData.value, searchHighCate.value, searchCate.value)
    if(!depth2) return

    const depth1Id = depth2.id.split('-')[0]

    selectedDepth1.value = [depth1Id]
    selectedDepth2.value = [depth2.id]
    return
  }

  if(searchHighCate.value) {
    const depth1 = findDepth1ByCode(filterMenuData.value, searchHighCate.value)
    if (!depth1) return

    selectedDepth1.value = [depth1.id]
    return
  }
}

const findDepth1ByCode = (list: any[], code: string) => {
  return list.find(item => item.id.split('-').length === 1 && item.hcCtgrCd === code) ?? null
}

const findDepth2ByCode = (list: any[], highCode: string, cateCode: string) => {
  for (const depth1 of list) {
    if(depth1.hcCtgrCd !== highCode) continue

    const found = (depth1.child || []).find((depth2: any)=>
          depth2.id.split('-').length === 2 && depth2.hcCtgrCd === cateCode)

    if(found) return found
  }

  return null
}

const findDepth3ByCode = (list: any[], highCode: string, cateCode: string, brandCode: string) => {
  for (const depth1 of list) {
    if(depth1.hcCtgrCd !== highCode) continue
    for (const depth2 of depth1.child || []) {
      if(depth2.hcCtgrCd !== cateCode) continue
      const found = (depth2.child || []).find((depth3: any)=>
          depth3.id.split('-').length === 3 && depth3.hcBrndCd === brandCode)

      if(found) return found
    }
  }

  return null
}

const buildCategoryTree = (rows:CategoryRow[]): MenuData[] => {
  const sortedRows = [...rows].sort((a, b) => a.path.localeCompare(b.path))

  const childrenMap = new Map<String, CategoryRow[]>()
  const rootRows: CategoryRow[] = []

  sortedRows.forEach((row) => {
    const parentId = (row.highHcCtgrCd || '').trim()

    if(!parentId) {
      rootRows.push(row)
      return
    }

    if(!childrenMap.has(parentId)) {
      childrenMap.set(parentId, [])
    }

    childrenMap.get(parentId)!.push(row)
  })

  const makeNode = (row: CategoryRow, displayId: string, visited: Set<string> = new Set()): MenuData => {
    const currentId = (row.hcCtgrCd || '').trim()

    if ( visited.has(currentId)) {
      return {
        hcBrndCd: row.hcBrndCd,
        hcCtgrCd: row.hcCtgrCd,
        id: displayId,
        text: row.hcCtgrNm,
        qty: Number(row.qty ?? 0),
        child: [],
      }
    }

    const nextVisited = new Set(visited)

    nextVisited.add(currentId)

    const children = (childrenMap.get(row.hcCtgrCd) || []).filter(child => child.hcCtgrCd !== row.hcCtgrCd)

    return {
      hcBrndCd: row.hcBrndCd,
      hcCtgrCd: row.hcCtgrCd,
      id: displayId,
      text: row.hcCtgrNm,
      qty: Number(row.qty ?? 0),
      child: children.map((child, index) => makeNode(child, `${displayId}-${index + 1}`, nextVisited)),
    }
  }

  return rootRows.map((row, index)=> makeNode(row, `${index + 1}`))
}

 // 필터 대분류 각 분류에 따라 버튼 선택시 보임/숨김
const handleCategoryPreview = (id: string) => {
  // 카테고리 버튼 선택시 보임/숨김
  if (id === 'cate') {
    isCategoryVisible.value = !isCategoryVisible.value;
  }
  // 브랜드 버튼 선택시 보임/숨김
  if (id === 'brand') {
    isBrandVisible.value = !isBrandVisible.value;
  }
  // 가격 버튼 선택시 보임/숨김
  if (id === 'price') {
    isPriceVisible.value = !isPriceVisible.value;
  }
}

const flattenCategoryList = (list: any[]) => {
  const result: any[] =[]

  const loop = (items: any[]) => {
    items.forEach(item => {
      result.push(item)

      if(item.child && item.child.length > 0) {
        loop(item.child)
      }
    })
  }

  loop(list)
  return result
}

const allCategoryItems = computed(() => flattenCategoryList(filterMenuData.value))

const categoryMapById = computed(() => {
  const map = new Map()

  allCategoryItems.value.forEach(item => {
    map.set(item.id, item)
  })

  return map
})

const getCodesByIds = (ids: string[], codeKey: 'hcCtgrCd' | 'hcBrndCd') => {
  return [...new Set(
    ids.map(id => categoryMapById.value.get(id))
       .filter(item => item && item[codeKey])
       .filter(item => item && item.qty > 0)
       .map(item => item[codeKey])
  )]
}

const getCodesByIds2 = (ids: string[], codeKey: 'hcCtgrCd' | 'hcBrndCd') => {
  return [...new Set(
    ids.map(id => categoryMapById.value.get(id))
       .filter(item => item && item[codeKey])
       .map(item => item[codeKey])
  )]
}

const filterProductList = () => {
  loadingStatus.value.full = true

  const depth1CategoryCodes = getCodesByIds(selectedDepth1.value, 'hcCtgrCd')
  if (depth1CategoryCodes.length > 0) {
    searchHighCate.value = depth1CategoryCodes.join(',')
  }

  const depth2CategoryCodes = getCodesByIds(selectedDepth2.value, 'hcCtgrCd')
  if(getQuery(route.query.searchCategory) != '' && getQuery(route.query.searchCategory) != null && getQuery(route.query.searchCategory) != undefined) {
    searchCate.value = getQuery(route.query.searchCategory)
    if(depth2CategoryCodes.length < 1 && getCodesByIds2(selectedDepth2.value, 'hcCtgrCd')) searchCate.value = 'pass'
  } else {
    if (depth2CategoryCodes.length > 0) {
      searchCate.value = depth2CategoryCodes.join(',')
    } else {
      searchCate.value = ''
    }
  }

  const depth3BrandCodes = getCodesByIds(selectedDepth3.value, 'hcCtgrCd')
  if (depth3BrandCodes.length > 0) {
    searchBrand.value = depth3BrandCodes.join(',')
  } else {
    searchBrand.value = ''
  }

  if(depth1CategoryCodes.length == 0 && depth2CategoryCodes.length == 0 && depth3BrandCodes.length == 0 && searchMinPriceStr.value == '0' && searchMaxPriceStr.value == '0')
  {
    loadingStatus.value.full = false
    //showAlert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "필터조건을", "선택"));
    return;
  }

  if (searchMinPrice.value > searchMaxPrice.value) {
    showAlert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "필터조건(가격)을", "확인"));
    loadingStatus.value.full = false
    return false;
  }
  if(depth1CategoryCodes.length == 0 && depth2CategoryCodes.length == 0 && depth3BrandCodes.length == 0 && (searchMinPriceStr.value != '0' || searchMaxPriceStr.value != '0')){
    searchCate.value = getQuery(route.query.searchCategory)
    searchHighCate.value = getQuery(route.query.searchHighCategory)
    searchBrand.value = getQuery(route.query.searchBrand)
  }

  isFiltered.value = true
  currentPage.value = 1
  rowPerPage.value = Number(stringRowPerPage.value)
  searchProductList('')

}
// 사용자가 선택한 각 depth의 id를 저장하는 ref
const selectedDepth1 = ref<string[]>([])
const selectedDepth2 = ref<string[]>([])
const selectedDepth3 = ref<string[]>([])

const toggleSelected = (target: Ref<string[]>, id: string) => {
  const index = target.value.indexOf(id)

  if (index > -1) {
    target.value.splice(index, 1)
  } else {
    target.value.push(id)
  }
}


const findItemById = (items: any[] =[], targetId: string): any => {
    for (const item of items) {
      if (item.id === targetId) return item
      
      if(item.child?.length) {
        const found = findItemById(item.child, targetId)
        if(found) return found
      }
    }

    return null
}

const collectIdsByDepth = (items: any[], depth: number): string[] => {
  const result: string[] =[]

  const loop = (list: any[] = []) => {
    list.forEach(item => {
      if (getDepthById(item.id) === depth) {
        result.push(item.id)
      }

      if ( item.child?.length) {
        loop(item.child)
      }   
   })
 
  }

  loop(items)
  return result
}

const sumQtyByIds = (ids: string[]) => {
  return ids.reduce((sum, id) => {
    const item = categoryMapById.value.get(id)
    return sum + Number(item?.qty ??0)
  }, 0)
}

const removeIds = (target: Ref<string[]>, ids: string[]) =>{
  target.value = target.value.filter(id=> !ids.includes(id))
}

const resetAllSearchResult = async () => {
  
  isCategoryVisible.value = true
  isBrandVisible.value = true
  isPriceVisible.value = true

  selectedDepth1.value = []
  selectedDepth2.value = []
  selectedDepth3.value = []

  productList.value = [...originalProductList.value]
  searchPriceRange.value = ''
  searchMinPriceStr.value = ''
  searchMaxPriceStr.value = ''
  searchMinPrice.value = 0
  searchMaxPrice.value = 0

  loadingStatus.value.full = true
  isFiltered.value = false
  activeId.value = 1  
  searchText.value = getQuery(route.query.searchWords)
  searchCate.value = getQuery(route.query.searchCategory)
  searchHighCate.value = getQuery(route.query.searchHighCategory)
  searchBrand.value = getQuery(route.query.searchBrand)
  searchMassCd.value = getQuery(route.query.searchMassCd)

  await searchCategoryList()
}

const addProduct = () => {
  currentPage.value = currentPage.value + 1
  searchProductList('add')
  // selectItem(activeId.value)
  // filterProductList()
}

const initAllDepthSelected = () => {
  if(!filterMenuData.value?.length) return
  productList.value = []
  const deptg1Ids: string[] = []
  const deptg2Ids: string[] = []
  const deptg3Ids: string[] = []

  const traverse = (items: any [] = []) => {
    items.forEach((item) => {
      const depth = getDepthById(item.id)

      if ( depth === 1) deptg1Ids.push(item.id)
      if ( depth === 2) deptg2Ids.push(item.id)
      if ( depth === 3) deptg3Ids.push(item.id)

      if ( item.child?.length) {
        traverse(item.child)
      }
    })
  }

  traverse(filterMenuData.value)

  // selectedDepth1.value = deptg1Ids
  // selectedDepth2.value = deptg2Ids
  // selectedDepth3.value = deptg3Ids

  isCategoryVisible.value = true
  isBrandVisible.value = true
  isPriceVisible.value = true

  productList.value = [...originalProductList.value]
  searchPriceRange.value = ''
  searchMinPriceStr.value = ''
  searchMaxPriceStr.value = ''
  searchMinPrice.value = 0
  searchMaxPrice.value = 0
}
// 상위 depth 변경하면 하위 depth는 초기화
const selectDepth1 = (id: string) => {
  const isAlreadySelected = selectedDepth1.value.includes(id)
  selectedDepth1.value = []
  selectedDepth2.value = []
  selectedDepth3.value = []

  if(isAlreadySelected) return
  const depth1 = findItemById(filterMenuData.value, id)
  if(!depth1) return

  const depth2Ids = collectIdsByDepth(depth1.child || [], 2)
  const depth3Ids = collectIdsByDepth(depth1.child || [], 3)

  const depth2QtySum = sumQtyByIds(depth2Ids)

  if (depth2QtySum === 0) return
  
  selectedDepth1.value = [id]
  selectedDepth2.value = depth2Ids
  // selectedDepth3.value = depth3Ids
  
  filterProductList();
}

// 2depth 선택 시 단건 선택
const selectDepth2 = (id: string) => {

  toggleSelected(selectedDepth2, id)

  const parentDepth1Id = id.split('-')[0]
  const parentDepth1 = findItemById(filterMenuData.value, parentDepth1Id)
  if(!parentDepth1) return
  
  const depth2Ids = collectIdsByDepth(parentDepth1.child || [], 2)
  const depth3Ids = collectIdsByDepth(parentDepth1.child || [], 3)

  const currentDepth2 = findItemById(parentDepth1.child || [], id)
  const currentDepth3Ids = collectIdsByDepth(currentDepth2?.child || [], 3)

  if(!selectedDepth2.value.includes(id)){
    removeIds(selectedDepth3, currentDepth3Ids)
  }

  const selectedChildDepth2Ids = depth2Ids.filter(depth2Id => selectedDepth2.value.includes(depth2Id))

  const selectedQtySum = sumQtyByIds(selectedChildDepth2Ids)

  if ( selectedQtySum === 0) {
    // selectedDepth1.value = selectedDepth1.value.filter(v => v!== parentDepth1Id)
    removeIds(selectedDepth2, depth2Ids)
    removeIds(selectedDepth3, currentDepth3Ids)
    filterProductList();
    return
  } 

  if (!selectedDepth1.value.includes(parentDepth1Id)) {
    selectedDepth1.value.push(parentDepth1Id)
  }

  filterProductList();
}

// 3depth 선택시 다건 선택
const selectDepth3 = (id: string) => {
  toggleSelected(selectedDepth3, id)

  const parentDepth1Id = id.split('-')[0]
  const parentDepth2Id = id.split('-').slice(0,2).join('-')

  const parentDepth1 = findItemById(filterMenuData.value, parentDepth1Id)
  const parentDepth2 = findItemById(filterMenuData.value, parentDepth2Id)

  if (!parentDepth1 || !parentDepth2) return

  const depth3Ids = collectIdsByDepth(parentDepth2.child || [], 3)

  const selectedDepth3Ids = depth3Ids.filter(depth3Ids => selectedDepth3.value.includes(depth3Ids))

  const selectedDepth3QtySum = sumQtyByIds(selectedDepth3Ids)

  if ( selectedDepth3Ids.length === 0) {
    // selectedDepth2.value = selectedDepth2.value.filter(v=> v !== parentDepth2Id)
    removeIds(selectedDepth3, depth3Ids)
  }

  const depth2Ids = collectIdsByDepth(parentDepth1.child || [], 2)

  const selectedDepth2Ids = depth2Ids. filter(depth2Id => selectedDepth2.value.includes(depth2Id))

  const selectedDepth2QtySum = sumQtyByIds(selectedDepth2Ids)

  if ( selectedDepth2QtySum === 0) {
    selectedDepth1.value = selectedDepth1.value.filter(v => v !== parentDepth1Id)

    const allDepth3Ids = collectIdsByDepth(parentDepth1.child|| [],3)

    removeIds(selectedDepth2, depth2Ids)
    removeIds(selectedDepth3, allDepth3Ids)

  }

  filterProductList();
}

// 해당 메뉴에 2뎁스 아이템이 하나라도 있는지 확인
const has2DepthChild = (depth1: any): boolean => {
  return depth1.child?.some((item: any) => getDepthById(item.id) === 2) ?? false
}

// 리스트에서 2뎁스 아이템만 필터링
const filter2DepthItems = (items: any[] = []) => {
  return items.filter(item => getDepthById(item.id) === 2).filter(item => item.qty > 0)
}

// id패턴에 따라 depth 판별(1-1은 2뎁스, 1-1-1은 3뎁스)
const getDepthById = (id: string): number => {
  const parts = id.split('-')
  return parts.length
}

// const getDepth1ById = (id:string) => {
//   return filterMenuData.value.find((item:any) => item.id === id)
// }

// const getDepth2Items = (depth1:any) => {
//   return (depth1.child || []).filter((item: any) => getDepthById(item.id) === 2)
// }

// 해당 1depth, 2depth 선택 안된 경우 3depth 전체 보임 2depth 선택시 해당 3depth 보임
const depth3List = computed((): MenuData[] => {
  if (!filterMenuData.value?.length) return []

  const result : MenuData[] = []

  filterMenuData.value.forEach((depth1) => {
    if(!selectedDepth1.value.includes(depth1.id)) return

    const depth2Items = depth1.child || []

    depth2Items.forEach((depth2: any) => {
      const depth2Depth = getDepthById(depth2.id)

      if (depth2Depth === 3) {
        result.push(depth2)
        return
      }

      if (depth2Depth === 2 && selectedDepth2.value.includes(depth2.id)) {
        const depth3Items = depth2.child || []

        depth3Items.forEach((depth3: any) => {
          if (getDepthById(depth3.id) === 3) {
            result.push(depth3)
          }
        })
      }
    })
  })
  return result.filter(item => item.qty > 0)
})

// 모든 뎁스에 공통으로 사용할 스크롤 튐 방지 함수
const handlePreventJump = (e: MouseEvent, callback: () => void): void => {
  // 브라우저의 기본 포커스 및 자동 스크롤 동작 차단
  e.preventDefault()
  
  // 스크롤 없이 포커스만 수동 부여
  const target = e.target as HTMLInputElement
  if (target) {
    target.focus({ preventScroll: true })
  }

  // 인자로 받은 실제 로직 실행
  callback()
}
  </script>
  <style lang="scss" scoped>
  @use "@/assets/scss/pc/display-hcon.scss" as *;
  </style>